import React, { useState, useEffect } from 'react';
import { TextField, Button, Container, Typography, MenuItem } from '@mui/material';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import empresasApi from '../api/empresasApi';

function EmpresaForm() {
  const [empresa, setEmpresa] = useState({
    nombre_empresa: '',
    nro_doc_empresa: '',
    contacto_empresa: '',
    telefono_empresa: '',
    email_empresa: '',
    id_pais: '',
  });
  const [paises, setPaises] = useState([]);
  const { id } = useParams();  // Obtiene el ID de la empresa si estamos editando
  const navigate = useNavigate();

  useEffect(() => {
    fetchPaises();
    if (id) {
      fetchEmpresa(id);  // Si estamos editando, carga los datos de la empresa
    }
  }, [id]);

  const fetchPaises = async () => {
    try {
      // TODO: Crear paisesApi cuando se migre a V1
      const response = await axios.get('http://localhost:3000/api/paises');
      setPaises(response.data);
    } catch (error) {
      console.error('Error al obtener los países:', error);
    }
  };

  const fetchEmpresa = async (id) => {
    try {
      const response = await empresasApi.obtener(id);
      setEmpresa(response.data);
    } catch (error) {
      console.error('Error al obtener la empresa:', error);
    }
  };

  const handleChange = (e) => {
    setEmpresa({ ...empresa, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await empresasApi.actualizar(id, empresa);
      } else {
        await empresasApi.crear(empresa);
      }
      navigate('/admin/empresas');
    } catch (error) {
      console.error('Error al guardar la empresa:', error);
    }
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h4" gutterBottom>
        {id ? 'Editar Empresa' : 'Crear Empresa'}
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Nombre de la Empresa"
          variant="outlined"
          fullWidth
          margin="normal"
          name="nombre_empresa"
          value={empresa.nombre_empresa}
          onChange={handleChange}
          required
        />
        <TextField
          label="Número de Documento"
          variant="outlined"
          fullWidth
          margin="normal"
          name="nro_doc_empresa"
          value={empresa.nro_doc_empresa}
          onChange={handleChange}
        />
        <TextField
          label="Contacto"
          variant="outlined"
          fullWidth
          margin="normal"
          name="contacto_empresa"
          value={empresa.contacto_empresa}
          onChange={handleChange}
        />
        <TextField
          label="Teléfono"
          variant="outlined"
          fullWidth
          margin="normal"
          name="telefono_empresa"
          value={empresa.telefono_empresa}
          onChange={handleChange}
        />
        <TextField
          label="Email"
          variant="outlined"
          fullWidth
          margin="normal"
          name="email_empresa"
          value={empresa.email_empresa}
          onChange={handleChange}
          required
        />
        <TextField
          select
          label="País"
          variant="outlined"
          fullWidth
          margin="normal"
          name="id_pais"
          value={empresa.id_pais}
          onChange={handleChange}
          required
        >
          {paises.map((pais) => (
            <MenuItem key={pais.id_pais} value={pais.id_pais}>
              {pais.det_pais} ({pais.simbolo_moneda})
            </MenuItem>
          ))}
        </TextField>
        <Button variant="contained" color="primary" type="submit" fullWidth style={{ marginTop: '20px' }}>
          {id ? 'Guardar Cambios' : 'Crear Empresa'}
        </Button>
      </form>
    </Container>
  );
}

export default EmpresaForm;
